import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [activeProgram, setActiveProgramState] = useState(
    localStorage.getItem("kp_active_program") || null
  );

  useEffect(() => {
    const token = localStorage.getItem("kp_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("kp_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("kp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("kp_token");
    localStorage.removeItem("kp_active_program");
    setActiveProgramState(null);
    setUser(false);
  };

  const setActiveProgram = (pid) => {
    if (pid) localStorage.setItem("kp_active_program", pid);
    else localStorage.removeItem("kp_active_program");
    setActiveProgramState(pid);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, login, logout, activeProgram, setActiveProgram }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
